import { render } from "./home-co.vue?vue&type=template&id=138173b4"
import script from "./home-co.vue?vue&type=script&lang=js"
export * from "./home-co.vue?vue&type=script&lang=js"

import "./home-co.vue?vue&type=style&index=0&id=138173b4&lang=css"

import exportComponent from "C:\\Users\\bodin\\Documents\\projects\\lescouleursdelavie\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__